// extracted by mini-css-extract-plugin
export var backButton = "_q-1";
export var content = "_q-d";
export var continueButton = "_q-7";
export var continueHint = "_q-8";
export var continueRow = "_q-6";
export var leftInner = "_q-0";
export var shell = "_q-e";
export var sidebarContent = "_q-5";
export var skipButton = "_q-c";
export var spacer = "_q-2";
export var spin = "_q-a";
export var spinner = "_q-9";
export var spinnerOverlay = "_q-b";
export var subtitle = "_q-4";
export var title = "_q-3";